'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.getWidth = getWidth;
exports.getHeight = getHeight;
exports.resizeEvent = resizeEvent;
var _lodash = require('lodash.throttle');
var _lodash2 = _interopRequireDefault(_lodash);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// action
var SET_WINDOW = '@@redux-window/SET_WINDOW';

// reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    width: window.innerWidth,
    height: window.innerHeight
  };
  var action = arguments[1];
  switch (action.type) {
    case SET_WINDOW:
      {
        return {
          width: action.width,
          height: action.height
        };
      }
    default:
      {
        return state;
      }
  }
}
;

// action creator
function setWindow(width, height) {
  return {
    type: SET_WINDOW,
    width: width,
    height: height
  };
}

// selectors
function getWidth(state) {
  return state.reduxWindow.width;
}
function getHeight(state) {
  return state.reduxWindow.height;
}

// function for listening to the window
function resizeEvent(store) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  window.addEventListener('resize', (0, _lodash2.default)(function () {
    store.dispatch(setWindow(window.innerWidth, window.innerHeight));
  }, wait));
}